
import { Vue } from "vue-class-component";

export default class CheckWhite extends Vue {}
